import useBurgerworksSalesByOrigin, {
  IDataType as IBurgerworksSalesByOriginDataType,
} from './useBurgerworksSalesByOrigin'
import useBurgerworksSalesMixItems, {
  IDataType as IBurgerworksSalesMixItemsDataType,
} from './useSalesMixItems'

export type IVariablesType =
  | 'burgerworksSalesByOrigin'
  | 'burgerworksSalesMixItems'
export type IDataType = IBurgerworksSalesByOriginDataType &
  IBurgerworksSalesMixItemsDataType

export const hooks = [
  ['burgerworksSalesByOrigin', useBurgerworksSalesByOrigin],
  ['burgerworksSalesMixItems', useBurgerworksSalesMixItems],
] as const
